'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThumbnailMetadata = exports.getFileMetadata = exports.getFileId = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _resolvedAttachmentKeyPaths = require('../constants/resolvedAttachmentKeyPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFileId = exports.getFileId = (0, _getIn2.default)(_resolvedAttachmentKeyPaths.FILE_ID);

var getFileMetadata = exports.getFileMetadata = (0, _getIn2.default)(_resolvedAttachmentKeyPaths.FILE_METADATA);

var getThumbnailMetadata = exports.getThumbnailMetadata = (0, _getIn2.default)(_resolvedAttachmentKeyPaths.THUMBNAIL_METADATA);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/resolved-attachment/operators/resolvedAttachmentGetters.js
// module id = 540
// module chunks = 2 3